import { deriveRollupContextForCardView, getParentRowsAfterRollupForCardView, getUniqueParentRowsFromLidUsingMap} from "./helper";
import { cleanupPredecessorSuccessorLinksForCardView } from "./rowChangePropagation";

type CardViewChanges = {
    deletedCardIds: string[];
    insertedCards: Row[];
    updatedCards: Partial<Row>[];
  };
  
  type ApplyResult = {
    rows: Row[];
    deletedRows: Row[];
    insertedRows: Row[];
    updatedRows: Row[];
  };
  type Row = {
    [key: string]: any;
};
interface ParentRollupResult {
  parentRowsAffectedByRollup: any[];
  additionalParentAndExtraRowsForUndo: any[];
  mergedRowsAfterRollupAndPredecessorChange: any[];
}

let cachedRowByIdMap: Map<number, any> | null = null;
let cachedRowsRef: any[] | null = null;


export const buildRowByIdMap = (rows) => {
  const map = new Map();
  for (const row of rows) {
    map.set(row.id, row);
  }
  return map;
};
export const getRowByIdMap = (rows) => {
  if (rows !== cachedRowsRef) {
    cachedRowsRef = rows;
    cachedRowByIdMap = buildRowByIdMap(rows);
  }
  return cachedRowByIdMap;
};

  export function applyCardViewChangesToGrid(
    rows: Row[],
    dependencyMap:any,
    headerNameToColObjForCard:any,
    loggedInUser,
    changes: CardViewChanges,
   
    options?: {
      predecessorColumn?: any;
    }
  ): ApplyResult {
    const {
      deletedCardIds = [],
      insertedCards = [],
      updatedCards = [],
    } = changes;
  
  
    let workingRows = [...rows];
    /* --------------------------------------------------
     * STEP 1: DELETE ROWS
     * -------------------------------------------------- */
    const deleteSet = new Set(deletedCardIds);
    const deletedRows: Row[] = [];
  
    workingRows = workingRows.filter(row => {
      if (deleteSet.has(row.id)) {
        deletedRows.push(row);
        return false;
      }
      return true;
    });
  
    /* --------------------------------------------------
     * STEP 2: INSERT ROWS
     * -------------------------------------------------- */
    const insertedRows: Row[] = [];
  
    if (insertedCards.length) {
      insertedCards.forEach(card => {
        const row: Row = {
          ...card,
        };
        workingRows.push(row);
        insertedRows.push(row);
      });
    }
  
    /* --------------------------------------------------
     * STEP 3: UPDATE ROWS
     * -------------------------------------------------- */
    const updatedRowMap = new Map<string, Partial<Row>>();
    updatedCards.forEach(update => {
      if (update.id) {
        updatedRowMap.set(update.id, update);
      }
    });
  
    let updatedRows: Row[] = [];
  
    workingRows = workingRows.map(row => {
      const update = updatedRowMap.get(row.id);
      if (!update) return row;
  
      const updatedRow = { ...row, ...update };
      updatedRows.push(updatedRow);
      return updatedRow;
    });
    const rowByIdMap = getRowByIdMap(workingRows);
    /* --------------------------------------------------
     * STEP 4: CLEAN PREDECESSORS
     * (you will replace this with your logic)
     * -------------------------------------------------- */
    if (deletedRows.length) {
      cleanupPredecessors(
        workingRows,
        deletedRows,
        options?.predecessorColumn,
        dependencyMap,
        deletedCardIds,
        rowByIdMap
        
      );
    }
  
    /* --------------------------------------------------
     * STEP 5: RECALCULATE ROLLUPS
     * (hook point for your rollup engine)
     * -------------------------------------------------- */
    
    
    const rollupContext = deriveRollupContextForCardView(
      headerNameToColObjForCard
    );
    let parentNodes = new Set()
    const uniqueParentsOfAllRows = getUniqueParentRowsFromLidUsingMap(
      rowByIdMap,
      [...deletedRows,...updatedRows]
    );
    for (const parent of uniqueParentsOfAllRows) {
      parentNodes.add(parent);
    }

    
    if(!parentNodes.size){

    }
    const {
      parentRowsAffectedByRollup,
      additionalParentAndExtraRowsForUndo,
      mergedRowsAfterRollupAndPredecessorChange,
    } = getParentRowsAfterRollupForCardView(
      [] ,
      parentNodes,
      rollupContext,
      getRowByIdMap,loggedInUser,rowByIdMap,workingRows
    );
    updatedRows=[...updatedRows,...parentRowsAffectedByRollup]
    console.log(" parentRowsAffectedByRollup additionalParentAndExtraRowsForUndo mergedRowsAfterRollupAndPredecessorChange", 
    
    additionalParentAndExtraRowsForUndo,
    mergedRowsAfterRollupAndPredecessorChange,)
    
    
  
    /* --------------------------------------------------
     * STEP 6: FINAL VALIDATION
     * -------------------------------------------------- */
    validateGridRows(workingRows);
  
    return {
      rows: workingRows,
      deletedRows,
      insertedRows,
      updatedRows,
    };
  }
  function cleanupPredecessors(
    rows: Row[],
    deletedRows: any,
    predecessorColumn: any,
    dependencyMap,
    deletedCardIds,
    rowByIdMap
  ) {
    const {
      updatedRows,
      undoRows,
    } = cleanupPredecessorSuccessorLinksForCardView({
      rowsToDeleteIds :deletedCardIds,
      dependencyMap,
      rowByIdMap,
      predecessorColumn,
    }); 
    return { updatedRows,
      undoRows}
  }
  function recalculateRollupsAfterCardChanges(
    rows: Row[],
    context: {
      deletedRows: Row[];
      insertedRows: Row[];
      updatedRows: Row[];
    }
  ): Row[] {
    // 🔴 Replace with your existing rollup logic
    return rows;
  }
  function validateGridRows(rows: Row[]) {
    // circular dependency
    // invalid predecessor refs
    // orphan children
  }
      